import { Tooltip } from 'antd';
import { EyeInvisibleOutlined } from '@ant-design/icons';

import {
  decimalNumberFormatter,
  numberFormatter,
  numberShortFormatter,
} from '../../utils/numberFormatter';
import { useUserContext } from '../../context/PermissionsContext';

const FinancialData = ({
  text,
  formatType = 'decimal',
  forceShow,
  forceHidden = true,
}: {
  text: number;
  formatType?: 'short' | 'long' | 'decimal';
  forceShow?: boolean;
  forceHidden?: boolean;
}) => {
  const { canViewFinancials } = useUserContext();

  const canSeeFinancials = forceHidden && (canViewFinancials || forceShow);

  const functionToUse = {
    short: numberShortFormatter,
    long: numberFormatter,
    decimal: decimalNumberFormatter,
  };

  const formattedValue = functionToUse[formatType ?? 'long'](text ?? 0);

  if (canSeeFinancials && formatType === 'decimal') {
    const [firstPart, secondPart] = formattedValue.split('.');

    return (
      <div className={`${text === 0 ? 'text-[#CDCDCD]' : ''}`}>
        <span>{firstPart}</span>
        <span className="text-xsm">.{secondPart}</span>
      </div>
    );
  }

  return canSeeFinancials ? (
    <span>{formattedValue}</span>
  ) : (
    <div>
      <Tooltip title="You do not have permission to see financials">
        <EyeInvisibleOutlined />
      </Tooltip>
    </div>
  );
};

export default FinancialData;
